import { createSessionStorageManager } from '@qodana/blocks/lib/utils/storageManager'

import { QD_CLOUD_SESSION_STORAGE_KEY, SessionStorageUnits } from '../config/sessionStorage'

export const {
	getFromStorage: getFromSessionStorage,
	saveToStorage: saveToSessionStorage,
	removeUnitFromStorage: removeFromSessionStorage,
} = createSessionStorageManager(QD_CLOUD_SESSION_STORAGE_KEY)

export function markAuthRedirectAttempted() {
	saveToSessionStorage(SessionStorageUnits.authRedirectAttempted, true)
}

export function clearAuthRedirectState() {
	removeFromSessionStorage(SessionStorageUnits.authRedirectAttempted)
	removeFromSessionStorage(SessionStorageUnits.authRedirectTimestamp)
}
